module.exports = __webpack_public_path__ + "img/zhuanye-dingdan.30c2804f.svg";